import React from 'react';
// eslint-disable-next-line jira/restricted/styled-components, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { ThemeProvider } from 'styled-components';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import { ProjectSettingsController } from '@atlassian/jira-spa-apps-project-settings-common/src/components/routing-filter/index.tsx';
import ProformaProjectFormsSettings from './ui/main.tsx';

const ProformaProjectFormsSettingsPage = () => {
	const { data: projectContextData } = useProjectContext();

	if (!projectContextData) {
		return null;
	}

	return (
		<ProjectSettingsController projectKey={projectContextData.projectKey}>
			<ThemeProvider theme={{}}>
				<ProformaProjectFormsSettings projectContext={projectContextData} />
			</ThemeProvider>
		</ProjectSettingsController>
	);
};

export default ProformaProjectFormsSettingsPage;
